import { Fragment, useEffect, useState } from "react";
import { CollapseableCard, CreateButton } from "../../../../CommonElements";
import { Button, Col, Form, FormGroup, Input, Row } from "reactstrap";
import DataTable from "react-data-table-component";
import TableColumnsAnnouncement from "../../constants/TableColumnsAnnouncement";
import { useThemeContext } from "../../../../Context/ThemeContext";
import { filterBetweenDate, filterSearch } from "../../../../Utils/FilterItems";
import ModalBuatPengumuman from "./ModalBuatPengumuman";
import FilterComponent from "../../../FilterComponents/FilterComponent";
import { usePengumuman } from "../../../../Context/PengumumanContext";

const Pengumuman = (props) => {
  const pengumumanAPI = usePengumuman();
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [selectedFilterTanggal, setSelectedFilterTanggal] = useState("");
  const [pengumumanList, setPengumumanList] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [pending, setPending] = useState(true);
  const { ThemeContext } = useThemeContext();

  const toggle = () => setIsOpen(!isOpen);

  let isMounted = true;
  useEffect(() => {
    getPengumumanList();

    return () => {
      isMounted = false;
    };
  }, []);

  const getPengumumanList = async () => {
    pengumumanAPI.getPengumuman().then((res) => {
      setPengumumanList(res.data);
      setPending(false);
    });
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const filterData = (data) => {
    const filteredData = data
      .filter(
        filterBetweenDate(
          "date_created",
          "date_modified",
          selectedFilterTanggal
        )
      )
      .filter(filterSearch(["title", "username"], filterText));
    return filteredData;
  };

  const getSubHeaderComponent = () => (
    <Col>
      <Row>
        <Col>
          <Form className="row pt-3">
            <FormGroup>
              <Input
                type="date"
                onChange={(e) => setSelectedFilterTanggal(e.target.value)}
              />
            </FormGroup>
          </Form>
        </Col>
        <Col className="d-inline-flex justify-content-end align-items-center">
          <FilterComponent
            onFilter={(e) => {
              let newFilterText = e.target.value;
              setFilterText(newFilterText);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        </Col>
      </Row>
    </Col>
  );

  const ExpandedComponent = ({ data }) => (
    <div className="p-15">{data.description}</div>
  );

  return (
    <Fragment>
      <Col {...props}>
        <CollapseableCard title="Pengumuman">
          <div className="d-flex flex-column" style={{ height: "370px" }}>
            <div className="text-end mb-4">
              <Button color="success" onClick={toggle}>
                Buat Pengumuman
              </Button>
            </div>
            <DataTable
              columns={TableColumnsAnnouncement(getPengumumanList)}
              data={filterData(pengumumanList)}
              pagination
              paginationResetDefaultPage
              fixedHeader
              fixedHeaderScrollHeight="360px"
              dense
              highlightOnHover
              // subHeader
              // subHeaderComponent={getSubHeaderComponent()}
              expandableRows
              expandableRowsComponent={ExpandedComponent}
              // subHeaderAlign="right"
              persistTableHead
              progressPending={pending}
              theme={ThemeContext}
            />
          </div>
        </CollapseableCard>
      </Col>
      <ModalBuatPengumuman
        create
        resetState={getPengumumanList}
        toggle={toggle}
        isOpen={isOpen}
      />
    </Fragment>
  );
};

export default Pengumuman;
